import React from 'react';
import AuthGuard from './AuthGuard';

const OpenRequest = React.lazy(() => import("../pages/ConsentManagement/OpenRequest"));
const RequestsHistory = React.lazy(() => import("../pages/ConsentManagement/RequestsHistory"));

const ConsentRoutes = [
    {
        path: "consent/openrequest",
        element: <AuthGuard><OpenRequest /></AuthGuard>
    },
    {
        path: "consent/requesthistory",
        element: <AuthGuard><RequestsHistory /></AuthGuard>
    },
]

export default ConsentRoutes